import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardCable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyboardCable"><Path fillRule="evenodd" clipRule="evenodd" d="M19 5.5V2H17.5V4H5V8H1V22H23V8H6.5V5.5H19ZM9 16.5H15V18H9V16.5ZM6.5 16.5H5V18H6.5V16.5ZM5 12H6.5V13.5H5V12ZM10.5 12H9V13.5H10.5V12ZM13.5 12H15V13.5H13.5V12ZM19.0002 12H17.5002V13.5H19.0002V12ZM17.5 16.5H19V18H17.5V16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboardCable;
